<template>
  <div id="toBeAssign">
    <div class="query-form">
      <el-form :inline="true" :model="queryParams" ref="queryParams"
               @submit.native.prevent @keyup.enter.native="search">
        <el-form-item label="调解类型" prop="mediationType" label-width="80px">
          <el-select class="select-item" v-model="queryParams.mediationType" placeholder="请选择" clearable>
            <el-option v-for="(value,key) in dictMap.mediation_type" :key="key" :label="value" :value="key"/>
          </el-select>
        </el-form-item>
        <el-form-item label="调解方式" prop="mediationCategory" label-width="80px">
          <el-select class="select-item" v-model="queryParams.mediationCategory" placeholder="请选择" clearable>
            <el-option v-for="(value,key) in dictMap.mediation_category" :key="key" :label="value" :value="key"/>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-form-item label="选择日期" prop="dateRange" label-width="80px">
            <el-date-picker class="date-picker" v-model="queryParams.dateRange" type="daterange" range-separator="至"
                            start-placeholder="开始日期" end-placeholder="结束日期" style="width: 240px"
                            clearable value-format="yyyy-MM-dd">
            </el-date-picker>
          </el-form-item>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="search()">搜索</el-button>
          <el-button type="primary" icon="el-icon-refresh" @click="reset()">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="table-content">
      <el-table v-loading="loading" :data="tableData">
        <el-table-column type="index" label="序号" align="center" width="50"/>
        <el-table-column label="案件编码" prop="recordId" align="center" width="170"/>
        <el-table-column label="调解类型" prop="mediationType" align="center" width="100"
                         :formatter="({ mediationType }) => dictMap.mediation_type[mediationType]"/>
        <el-table-column label="调解方式" prop="mediationCategory" align="center" width="100"
                         :formatter="({ mediationCategory }) => dictMap.mediation_category[mediationCategory]"/>
        <el-table-column label="申请人" prop="applicant" align="center" width="90"/>
        <el-table-column label="调解状态" prop="status" align="center" width="100"
                         :formatter="({ status }) => dictMap.mediation_status[status]"/>
        <el-table-column label="纠纷诉求" prop="applicantReq" align="left" width="150" :show-overflow-tooltip="true"/>
        <el-table-column label="创建时间" prop="createTime" align="center" width="150"/>
        <el-table-column align="center" class-name="small-padding fixed-width" label="操作">
          <template v-slot="scope">
            <el-button size="mini" type="text"
                       @click="queryDetails(scope.row)">查看详情
            </el-button>
            <el-button size="mini" type="text"
                       @click="mediatorAssign(scope.row)">分配调解员
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <pagination class="pagination-class" v-show="pageInfo.total>0" :limit.sync="pageInfo.pageSize"
                  :page.sync="pageInfo.pageIndex"
                  :total="pageInfo.total" @pagination="getList"/>
    </div>
    <mediation-detail v-if="mediationDetailOpen" :open="mediationDetailOpen" @close="mediationDetailClose"
                      :dict-map="dictMap"
                      :recordInfo="mediationDetailInfo.recordInfo"
                      :accidentInfo="mediationDetailInfo.accidentInfo"
                      :personInfos="mediationDetailInfo.personInfos"/>
    <assign-mediator v-if="assignMediatorOpen" :open="assignMediatorOpen" @close="assignMediatorClose"
                     :record-id="currentRecordId"/>
  </div>
</template>

<script>
import {getDictMap} from '@/utils/dict/dictData';
import {getInfo, getList} from "@/api/mediation/mediation";
import MediationDetail from "@/views/mediator/MediationDetail";
import AssignMediator from "@/views/mediator/AssignMediator";

export default {
  name: 'ToBeAssign',
  components: {
    MediationDetail, AssignMediator,
  },
  data() {
    return {
      loading: true,
      dictMap: {mediation_type: {}, mediation_category: {}, mediation_status: {}},
      queryParams: {
        pageIndex: 1,
        pageSize: 10,
        mediationType: '',
        mediationCategory: '',
        dateRange: [],
        statusList: ['0'],
        beginTime: '',
        endTime: '',
      },
      pageInfo: {
        total: 0,
        pageIndex: 1,
        pageSize: 10,
      },
      tableData: [],
      currentRecordId: '',
      mediationDetailOpen: false,
      mediationDetailInfo: {
        recordInfo: {
          recordId: '',
          mediationType: '',
          mediationCategory: '',
          disputeDesc: '',
          applicantReq: '',
          status: '',
          createTime: '',
          updateTime: '',
        },
        accidentInfo: {},
        personInfos: [],
      },
      assignMediatorOpen: false,
    }
  },
  created() {
    this.reset();
    this.getList();
    getDictMap(this.dictMap).then(data => {
      this.dictMap = data;
    });
  },
  methods: {
    search() {
      this.pageInfo.pageIndex = 1;
      this.getList();
    },
    reset() {
      this.resetForm('queryParams');
    },
    getList() {
      this.loading = true;
      const dateRange = this.queryParams.dateRange;
      if (null != dateRange && '' !== dateRange) {
        this.queryParams.beginTime = dateRange[0];
        this.queryParams.endTime = dateRange[1];
      } else {
        this.queryParams.beginTime = '';
        this.queryParams.endTime = '';
      }
      getList(this.queryParams, this.pageInfo).then(response => {
          this.tableData = response.data.list;
          this.pageInfo.total = response.data.total;
          this.loading = false;
        }
      );
    },
    queryDetails(row) {
      const recordId = row.recordId;
      getInfo(recordId).then(response => {
        this.recordInfoWrapper(response.data);
        this.mediationDetailOpen = true;
      });
    },
    mediationDetailClose(data) {
      this.mediationDetailOpen = data;
    },
    recordInfoWrapper(data) {
      this.mediationDetailInfo.recordInfo.recordId = data.recordId;
      this.mediationDetailInfo.recordInfo.mediationType = data.mediationType;
      this.mediationDetailInfo.recordInfo.mediationCategory = data.mediationCategory;
      this.mediationDetailInfo.recordInfo.disputeDesc = data.disputeDesc;
      this.mediationDetailInfo.recordInfo.applicantReq = data.applicantReq;
      this.mediationDetailInfo.recordInfo.status = data.status;
      this.mediationDetailInfo.recordInfo.createTime = data.createTime;
      this.mediationDetailInfo.recordInfo.updateTime = data.updateTime;
      this.mediationDetailInfo.accidentInfo = data.accidentInfo;
      this.mediationDetailInfo.personInfos = data.personInfos;
    },
    mediatorAssign(row) {
      this.currentRecordId = row.recordId;
      this.assignMediatorOpen = true;
    },
    assignMediatorClose(data) {
      this.assignMediatorOpen = data.open;
      if (data.refresh) {
        this.getList();
      }
    },
  },

}
</script>

<style lang="less">
#toBeAssign {
  .query-form {
    margin-top: 10px;

    .select-item {
      width: 140px;
    }

    .date-picker .el-range-separator {
      color: #17ECFE;
    }

    .el-range-editor .el-range-input {
      color: #b1e3ff;
    }
  }

  .pagination-container {
    margin-top: -20px;
    margin-bottom: 40px;
    padding: 0;
  }
}
</style>
